/**
 * 弹窗关闭用的细 X
 */
export const CLOSE_DIALOG_ICON = 'danceng-guanbi-xixian';

export const SPECIAL_CHECKED = 'teshuxuanzedibiao';

export const GO_NEXT_PAGE_ICON = 'quanju-liebiaoyoujiantou';
